import React, {useEffect, useRef, useState} from "react";

const AudioVisualizer = ({width, height, color, is_opning, barCount = 40}) => {
    const canvasRef = useRef(null);
    const audioContextRef = useRef(null);
    const analyserRef = useRef(null);
    const animationFrameRef = useRef(null);
    const [hasMicAccess, setHasMicAccess] = useState(false);

    useEffect(() => {
        const startVisualizer = async () => {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({audio: true});

                setHasMicAccess(true);
                audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
                analyserRef.current = audioContextRef.current.createAnalyser();
                const source = audioContextRef.current.createMediaStreamSource(stream);
                source.connect(analyserRef.current);

                analyserRef.current.fftSize = 128;
                const bufferLength = analyserRef.current.frequencyBinCount;
                const dataArray = new Uint8Array(bufferLength);

                const drawVisualizer = () => {
                    if (!canvasRef.current || !analyserRef.current) return;
                    const canvas = canvasRef.current;
                    const ctx = canvas.getContext("2d");

                    analyserRef.current.getByteFrequencyData(dataArray);
                    ctx.clearRect(0, 0, canvas.width, canvas.height);

                    const effectiveCount = Math.min(barCount || bufferLength, bufferLength);
                    const barWidth = is_opning ? (canvas.width / effectiveCount) * 2.5 : (canvas.width / effectiveCount);
                    const barSpacing = is_opning ? barWidth * 0.6 : barWidth;
                    let barHeight;
                    let x = 0;

                    for (let i = 0; i < effectiveCount; i++) {
                        const dataIndex = Math.floor(i * (bufferLength / effectiveCount));
                        const value = dataArray[dataIndex];
                        barHeight = is_opning ? ((value / 2) * (is_opning ? 1.5 : 1)) / 5 : (value / 2) * (is_opning ? 1.5 : 1);
                        ctx.fillStyle = "#170A1C";
                        ctx.fillRect(x, canvas.height - barHeight / 2, barWidth, barHeight);
                        x += barWidth + barSpacing;
                    }

                    animationFrameRef.current = requestAnimationFrame(drawVisualizer);
                };

                drawVisualizer();
            } catch (err) {
                console.error("Error accessing microphone:", err);
            }
        };

        const handleVisibilityChange = () => {
            if (document.visibilityState !== "visible") {
                if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
            }

            if (document.visibilityState === "visible") {
                startVisualizer();
            }
        };

        const handlePageOnLoad = () => {
            startVisualizer();
        };

        startVisualizer();

        window.addEventListener("load", handlePageOnLoad);
        document.addEventListener("visibilitychange", handleVisibilityChange);
        document.addEventListener("click", handleVisibilityChange);

        return () => {
            window.removeEventListener("load", handlePageOnLoad);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            document.removeEventListener("click", handleVisibilityChange);
        };
    }, [is_opning, barCount]);

    return <canvas ref={canvasRef} width={width} height={height} style={{backgroundColor: color}}></canvas>;
};

export default AudioVisualizer;